// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popovers_popover__25B5D","label":"Popovers_label__2DZ94 typography_h3__3vtlZ","searchPopover":"SearchPopover_searchPopover__1k-WO Popovers_popover__25B5D"};